export default __webpack_public_path__ + "static/icon-solar-panels-4f0d0a51e85509f4f8a45698183c29e8.svg";